import { getDurationFrom } from './timeHelper'

export const GPS_TRACKER_COMMUNICATION_STALE_WARNING_MINUTES = 120
export const GPS_TRACKER_BATTERY_EMPTY_WARNING_MESSAGE = 'バッテリーが切れています。端末の状態を確認してください'
export const GPS_TRACKER_INTERNET_DISCONNECTED_WARNING_MESSAGE = '長時間インターネットに接続できていません。端末の状態を確認してください'

type GpsTrackerCommunicationStatus = {
  heartbeat_received_at?: string | null
  battery_percentage?: number | null
}

const getElapsedMinutes = (dateTime?: string | null): number | null => {
  if (!dateTime) return null

  const minutes = getDurationFrom(dateTime).asMinutes()

  return Number.isFinite(minutes) && minutes >= 0 ? minutes : null
}

export const getGpsTrackerCommunicationWarningMessage = (
  status?: GpsTrackerCommunicationStatus | null,
): string | null => {
  const communicationElapsedMinutes = getElapsedMinutes(status?.heartbeat_received_at)

  if (
    communicationElapsedMinutes === null
    || communicationElapsedMinutes < GPS_TRACKER_COMMUNICATION_STALE_WARNING_MINUTES
  ) {
    return null
  }

  if (status?.battery_percentage === 0) {
    return GPS_TRACKER_BATTERY_EMPTY_WARNING_MESSAGE
  }

  if (typeof status?.battery_percentage === 'number' && status.battery_percentage >= 1) {
    return GPS_TRACKER_INTERNET_DISCONNECTED_WARNING_MESSAGE
  }

  return null
}
